import { OrderingParam, SortKey, TabConfig } from '../../CustomersV2.types';

interface SortOption {
  value: OrderingParam;
  label: string;
}

interface SortGroup {
  /** Field heading shown above the group's radios. */
  heading: string;
  /** Radio options for this field, in display order. */
  options: SortOption[];
}

/**
 * Per-field drawer config: the group heading and its two direction options, in
 * display order. Date leads with descending ("Most recent") to match the tab
 * default; company leads with ascending ("A-Z").
 */
const FIELD_GROUPS: Record<SortKey, SortGroup> = {
  earliest_interacted_date: {
    heading: 'Date applied',
    options: [
      { value: '-earliest_interacted_date', label: 'Most recent' },
      { value: 'earliest_interacted_date', label: 'Oldest' },
    ],
  },
  buyer_name: {
    heading: 'Company name',
    options: [
      { value: 'buyer_name', label: 'A-Z' },
      { value: '-buyer_name', label: 'Z-A' },
    ],
  },
};

/**
 * Builds the mobile sort drawer's groups from a tab's sortable columns, one
 * group per sortable field in column order. Non-sortable columns are skipped.
 */
export function buildSortGroups(config: TabConfig): SortGroup[] {
  return config.columns.flatMap((col) =>
    col.sortKey ? [FIELD_GROUPS[col.sortKey]] : [],
  );
}

/** Field heading for a sort key, matching the drawer group it belongs to. */
export function sortFieldHeading(sortKey: SortKey): string {
  return FIELD_GROUPS[sortKey].heading;
}
